export default __webpack_public_path__ + "static/media/app-captura-fotos.bbf0459c.jpeg";